var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.variables && _vm.isOpen)?_c('apollo-query',{ref:"apolloQuery",attrs:{"client-id":"auctionGraphqlClient","query":require('@/graphql/queries/auctions/Auction.gql'),"variables":_vm.variables,"update":_vm.dataUpdated},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var ref_result = ref.result;
var loading = ref_result.loading;
var error = ref_result.error;
var data = ref_result.data;
var isLoading = ref.isLoading;
return [_c('auction-detail-modal',{ref:"modal",attrs:{"auction":_vm.auctionData},on:{"onClose":_vm.close,"onRefetch":_vm.refetch,"onDelete":function($event){return _vm.$emit('onDelete')}}})]}}],null,false,929400287)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }